/**
 * Deposit Method View
 */

define(function(require, exports, module) {
    'use strict';

    const $ = require('j');
    const _ = require('underscore');
    const core = require('core');
    const config = require('config');
    const i18n = require('i18n');
    const CashierMethodView = require('portlets/cashier/cashier.method.view');
    const user = require('user');
    const cashierUtil = require('modules/cashier/cashier.util');
    const utils = require('utils');
    const urlUtil = require('util/url.util');
    const { cashier } = require('bundle');
    const paymentUtil = require('common/payment.util');
    const Paysafe = require('portlets/cashier/deposit/special/paysafe.class');
    const WireCardDepositMethodView = require('portlets/cashier/deposit/special/wirecard-deposit.method.view');
    const EasyPGDepositMethodView = require('portlets/cashier/deposit/special/easypg-deposit.method.view');

    require('widgets/suggestions.widget');

    module.exports = CashierMethodView.extend({

        className: _.result(CashierMethodView.prototype, 'className') + ' fn-deposit-method',

        events: _.extend({}, CashierMethodView.prototype.events, {
            'submit form': 'handleSubmit',
            'change .fn-change-VC': 'handleChangeVC'
        }),

        defaultTemplateName: 'deposit.method',

        render: function() {
            var result = CashierMethodView.prototype.render.apply(this, arguments);
            var data;
            var tagName;

            this.fillPromoCode(cashierUtil.promoCode.getFromStorage());

            if (this.model.get('code') === 'VisaCheckout') {
                data = this.model.get('account')[0];
            } else if (this.model.get('code') === 'BankTransferCH') {
                tagName = 'uam/payments/bankReference/281459';
                this.form.showLoading();
                user.getPlayerTags(tagName)
                    .always(this.form.hideLoading.bind(this.form))
                    .done(function(response) {
                        var bankReferenceID = _.result(_.find(response.data.tags, 'name', tagName), 'value') || '';
                        var accountIdElement = $('#BankTransferCH-account-id');
                        accountIdElement.val(bankReferenceID).attr('disabled', true);
                    })
                    .fail(console.error);
            }

            this.initSuggestions(data);
            return result;
        },

        subscribe: function() {
            CashierMethodView.prototype.subscribe.apply(this, arguments);

            this.listenTo(core, {
                'storage:change:promoCode': this.fillPromoCode
            });

            this.eventsNamespace = '.deposit_method_' + _.uniqueId();
            this.$el.on('expand', this.handleExpandDepositItem.bind(this));
            $(window).on('resize' + this.eventsNamespace, _.debounce(this.handleWindowResize.bind(this), 200));
        },

        close: function() {
            $(window).off(this.eventsNamespace);
            this.$('.fn-suggestions-container').forEach(function(el) {
                el.widgets && el.widgets.suggestions.destroy();
            });

            CashierMethodView.prototype.close.apply(this, arguments);
        },

        handleChangeVC: function(e) {
            var account = _.findWhere(this.model.get('account'), { code: e.target.value });

            if (this.isSuggestionsAttached()) {
                var $suggestions = this.$('.fn-suggestions-container');

                $suggestions.suggestions('destroy');
                $suggestions.html('');
            }

            this.initSuggestions(account);
            this.handleExpandDepositItem();
        },

        initSuggestions: function(data) {
            var model = data || this.model.toJSON();
            var suggested = model.suggested || {};

            if (suggested.suggestion) {
                this.attachWidget(this.$('.fn-suggestions-container').suggestions({
                    paymentType: 'deposit',
                    enableSwipeLogic: false,
                    viewport: this.$el[0],
                    defaultValue: suggested.default || '',
                    suggestions: suggested.suggestion,
                    amountField: model.amountRequired ? this.form.$el[0].amount : null
                }));
            }
        },

        fillPromoCode: function(promoCodeValue) {
            this.$('[name=promoCode]').val(promoCodeValue || '');
        },

        handleSubmit: function(e) {
            e.preventDefault();
            this.depositAction();
        },

        handleExpandDepositItem: function() {
            /**
             * TODO: there is a case when for some reason a suggestion container
             * will be hidden (e.g. deposit method form) and need to wait when
             * it render properly for attaching swipe logic.
             */
            _.defer(function() {
                if (this.isSuggestionsAttached()) {
                    var $suggestions = this.$('.fn-suggestions-container');
                    $suggestions.suggestions('isSwipeAttached', function(isTrue) {
                        $suggestions.suggestions(isTrue ? 'alignSuggestions' : 'attachSwipe');
                    });
                }
            }.bind(this));
        },

        handleWindowResize: function() {
            if (this.isSuggestionsAttached()) {
                this.$('.fn-suggestions-container').suggestions('alignSuggestions');
            }
        },

        isSuggestionsAttached: function() {
            var $suggestions = this.$('.fn-suggestions-container');
            return $.isWidgetAttached($suggestions[0], 'suggestions');
        },

        /**
         * Override
         */

        addAnotherAccount: function(e) {
            CashierMethodView.prototype.addAnotherAccount.apply(this, arguments);

            if (this.model.get('code') === 'DotpayBlik') {
                var $bank = this.$('.fn-bank');
                $bank.html('');
            }

            this.handleAccountChange(e.target.value);
        },

        handleAccountChange: function(code) {
            var accounts = this.model.get('account');
            var account = _.findWhere(accounts, { code: code }) || {};

            var $cardConfirmation = this.$('.fn-card-confirmation');
            var $payPalBA = this.$('.fn-PayPalViaSC-BA');

            // card confirmation for CC
            if ($cardConfirmation.length) {
                $cardConfirmation.toggleClass('hidden', !account.storeCardConfirmationRequired);
            }

            // PayPal billing agreement
            if ($payPalBA.length) {
                $payPalBA.html(this.tmpl('deposit.method.PayPalViaSC.BA', {
                    selectedAccount: account,
                    accounts: accounts,
                    accountFields: this.model.get('accountFields')
                }));
            }
        },

        depositAction: function(options) {
            var extWindow;

            return this.form.validate().done(function(data, form) {
                if (this.model.get('reDirectType') === 'popup') { // Safari `window.open` hack
                    extWindow = window.open(
                        new URL(location.origin + '/' + config.get('themeName') + '/js/app-out/loading.html'),
                        '',
                        'resizable=yes, width=800px, height=600px'
                    );
                }

                data = _.extend({}, data, options);

                this.hideKeyboard();
                form.showLoading();

                data = this.model.resolveStoredAccount(data);

                this.model.deposit(data)
                    .always(response => {
                        this._handleClearSecureFields(response);
                        this._handleClearPromoCode(response, data);
                    })
                    .then(response => this.successDeposit(response, extWindow, data))
                    .fail(error => this.errorDeposit(data, error, extWindow, data))
                    .always(() => form.hideLoading());
            }.bind(this));
        },

        successDeposit: function(response, extWindow, data) {
            var deferred = $.Deferred();
            var resolve = deferred.resolve.bind(deferred);
            var reject = deferred.reject.bind(deferred);

            if (response.data.headerParameters) { // needs redirect
                switch (this.model.get('reDirectType')) {
                    case 'lightboxdt':
                        this.handleDataTransDeposit(response);

                        return deferred.resolve();

                    case 'seamlesswc':
                        this.handleWireCardDeposit(response);

                        return deferred.resolve();

                    case 'jseasypg':
                        this.handleEasyPGDeposit(response, deferred, data);

                        return deferred;

                    case 'jspaysafe':
                        this.handlePaysafeDeposit(response, deferred);

                        return deferred;
                }

                cashier.performRedirect(response, {
                        redirectType: this.model.get('reDirectType'),
                        extWindow: extWindow
                    })
                    .then(function(redirectResponse) {
                        this.handleRedirectMessage(redirectResponse, response)
                            .done(resolve)
                            .fail(reject);
                    }.bind(this))
                    .catch(reject);

                return deferred;
            }

            const { amount, status, code } = response.data?.payments?.transaction[0] ?? {};

            core.trigger('deposit:success', { amount, status, code, method: this.model.get('name') });
            // Send notification about success deposit
            core.trigger('app:message', {
                ID: 'successDeposit',
                data: {
                    message: 'Success deposit notification',
                    paymentsStatistics: user.get('paymentsStatistics')
                }
            });

            return deferred.resolve();
        },

        handleRedirectMessage: function(redirectResponse, response) {
            if (!redirectResponse) {
                return $.Deferred().resolve();
            }

            var headerParameters = response.data.headerParameters;
            var is3DSecure = Boolean(headerParameters['X-Redirect-Type']);
            var error = redirectResponse.error;
            var href = redirectResponse.href;
            var notifyData = error ? 'action=deposit&status=error&initiator=cashier_backbone' : href;

            if (is3DSecure) {
                if (error === 'LIGHTBOX_CLOSED') {
                    return cashierUtil.notifyTransactionStatus(notifyData);
                }

                return this.handle3DSecureRedirectResponse(redirectResponse, headerParameters);
            }

            return cashierUtil.notifyTransactionStatus(notifyData);
        },

        handle3DSecureRedirectResponse: function(redirectResponse, headerParameters) {
            var href = redirectResponse.href;
            var error = redirectResponse.error;
            var params = urlUtil.getURLParams(href);
            var status = params.status;

            var needSendRequest = status === '3DsNotification' || error === 'LIGHTBOX_TIMED_OUT_10S';

            if (needSendRequest) {
                return this.model
                    .send3DsMethodNotificationRequest(params, error, headerParameters)
                    .then(this.successDeposit.bind(this));
            }

            return $.Deferred().resolve();
        },

        errorDeposit: function(data, response, extWindow) {
            extWindow && extWindow.close();

            if (!response) {
                this.form.showErrorMessage({
                    translation: 'playtech.mobile.system.error.no.response'
                });

                return;
            }

            var errorMessage = response.data.errorMessage
                || response.data.error?.message
                || '';

            // Currency conversion, fee, 1st deposit confirmation
            var knownError = this.handleError(response.data.error);

            if (knownError) {
                data[knownError.type] = true;

                if (knownError.type === 'depositConfirmed' && cashierUtil.isPekoResponse(response)) {
                    errorMessage = response.data.error?.message || '';
                }

                window.Playtech.API.popup.showPopup('confirmation', {
                    title: response.data.error.severity || 'Warning',
                    content: errorMessage,
                    onAccept: this.depositAction.bind(this, data),
                    onDecline: this._clearSecureFields.bind(this)
                });
            } else {
                var pekoErrorMessage = cashierUtil.getErrorMessage(response);

                if (pekoErrorMessage) {
                    this.form.showErrorMessage({
                        content: pekoErrorMessage
                    });
                } else {
                    this.form.showErrorMessage({
                        translation: 'playtech.mobile.system.mobile-cashier.error.' + response.data.errorCode,
                        content: errorMessage
                    });
                }
            }

            this.handleSpecialPmsDepositError(data, response);

            core.trigger('deposit:fail', response.data);
        },

        handleSpecialPmsDepositError: function(data, response, extPaymentWindow) {
            if (this.model.get('code') === 'DotpayBlik') {
                this.handleDotpayBlikDepositError(data, response, extPaymentWindow);
            }
        },

        handleDotpayBlikDepositError: function(data, response) {
            var error = response.data.error;

            if (error.code === 'PAYMENTS-1041') {
                this.form.toggleFieldVisibility('account', false);
                this.form.toggleFieldVisibility('alt_account', false);
                this.form.toggleFieldVisibility('field1', true);
            }

            if (error.code === 'PAYMENTS-1040') {
                var $bank = this.$('.fn-bank');
                var altAccounts = error.errorDetails.alternativeAccount;
                var bankHtml = this.tmpl('deposit.method.DotpayBlik.bank', { accounts: altAccounts });

                $bank.html(bankHtml);
                this.form.wrapFormControl($bank.find('select')[0]);
            }
        },

        handleEasyPGDeposit: async function(response, deferred, data) {
            if (this._easyPGView) {
                this._easyPGView.close();
                this.childViews.splice(this.childViews.indexOf(this._easyPGView), 1);
            }

            this._easyPGView = new EasyPGDepositMethodView({
                onClose: () => {
                    this.form.$el.removeClass('hidden');
                    this._easyPGView.close();
                    this.childViews.splice(this.childViews.indexOf(this._easyPGView), 1);
                    this._easyPGView = null;
                }
            });

            this.form.$el.addClass('hidden');
            this.$('.fn-accordion-body').append(this._easyPGView.render().el);
            this.childViews.push(this._easyPGView);

            await this._easyPGView.initializeEasyPG(response, data);

            deferred.resolve();
        },

        handlePaysafeDeposit: function(response, deferred) {
            var options = paymentUtil.convertHeaderParameters(response.data.headerParameters);

            _.extend(options, {
                methodCode: this.model.get('code'),

                onPaysafeWindowClose: function() {
                    cashierUtil.showNotifyTransactionStatusPopup({
                        status: 'cancel',
                        title: i18n.t('playtech.mobile.system.mobile-cashier.cancel.title')
                    });

                    deferred.resolve();
                },

                onPaysafeDepositError: function(failResponse) {
                    if (failResponse) {
                        const transactionCode = failResponse?.data?.transactionData?.code;
                        const amount = failResponse?.data?.transactionData?.amount?.amount;

                        cashierUtil.notifyTransactionStatus(`initiator=cashier_backbone&action=deposit&status=error${transactionCode ? `&transactionCode=${transactionCode}` : ''}&amount=${amount}`);
                    }

                    deferred.resolve();
                },

                onPaysafeDepositSuccess: function(successResponse) {
                    core.trigger('deposit:paysafe');

                    if (successResponse) {
                        const transactionCode = successResponse?.data?.transactionData?.code;
                        const amount = successResponse?.data?.transactionData?.amount?.amount;

                        cashierUtil.notifyTransactionStatus(`initiator=cashier_backbone&action=deposit&status=success${transactionCode ? `&transactionCode=${transactionCode}` : ''}&amount=${amount}`);
                    }

                    deferred.resolve();
                }
            });

            new Paysafe(options);
        },

        handleWireCardDeposit: function(response) {
            if (this._wireCardView) {
                this._wireCardView.close();
                this.childViews.splice(this.childViews.indexOf(this._wireCardView), 1);
            }

            this._wireCardView = new WireCardDepositMethodView({
                data: this.form.selectedData,
                onClose: function(success) {
                    this._wireCardView.close();
                    this.form.$el.removeClass('hidden');

                    if (success) {
                        core.trigger('deposit:wirecard');
                    }
                }.bind(this)
            });

            this.form.$el.addClass('hidden');
            this.$('.fn-accordion-body').append(this._wireCardView.render().el);
            this._wireCardView.initializeWireCard(response.data.headerParameters.Location[0]);

            this.childViews.push(this._wireCardView);
        },

        handleDataTransDeposit: function(response) {
            var formDT;
            var urlParams = urlUtil.getURLParams(response.data.headerParameters['X-Redirect-Content'][0]);
            var formID = 'datatrans-' + utils.guid();
            var scriptURL = response.data.headerParameters.Location[0];
            // hack for resolving conflict with window.define in DataTrans script
            var cachedDefine = window.define;
            window.define = null;

            $.getScript(scriptURL, function() {
                window.define = cachedDefine;
                var optionsDT = {
                    form: '#' + formID,
                    closed: function() {
                        document.body.removeChild(formDT);
                    }
                };
                formDT = document.createElement('form');
                formDT.id = formID;
                Object.keys(urlParams).forEach(function(key) {
                    formDT.setAttribute(key, urlParams[key]);
                });
                document.body.appendChild(formDT);
                window.Datatrans && window.Datatrans.startPayment(optionsDT);
            });
        },

        _handleClearSecureFields: function(response) {
            const { data = {} } = response?.response || response || {};
            const knownError = this.handleError(data.error);

            if (!knownError) {
                this._clearSecureFields();
            }
        },

        _clearSecureFields: function() {
            this.form.$el.find('[type=password],[name=cvv],[name=cvv1],[name=cvv2],[name=cvv3]').val('');
        },

        _handleClearPromoCode: function(response, formData) {
            var data = response.data || {};
            var isRedirectPm = Boolean(data.headerParameters);

            if (isRedirectPm) {
                return;
            }

            var storedPromoCode = cashierUtil.promoCode.getFromStorage();

            if (storedPromoCode === formData.promoCode) {
                if (!data.error || data.errorCode === 3002) {
                    cashierUtil.promoCode.removeFromStorage();
                }
            } else if (data.errorCode === 3002) {
                this.fillPromoCode(storedPromoCode);
            }
        }

    });
});
